import { ethers } from 'ethers';
import { CONTRACTS } from '../config/contracts';
import GlobalLogicAbi from '../config/abis/GlobalLogic.json';
import GlobalStorageAbi from '../config/abis/GlobalStorage.json';
import ERC20Abi from '../config/abis/ERC20.json';

export const getLogicContract = (signerOrProvider) => {
  return new ethers.Contract(CONTRACTS.GlobalLogic, GlobalLogicAbi, signerOrProvider);
};

export const getStorageContract = (signerOrProvider) => {
  return new ethers.Contract(CONTRACTS.GlobalStorage, GlobalStorageAbi, signerOrProvider);
};

export const getUsdtContract = (signerOrProvider) => {
  return new ethers.Contract(CONTRACTS.USDT, ERC20Abi, signerOrProvider);
};
